import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'rolePermissionGroups';
export const rolePermissionGroupsActions = makeActions(
  MODEL_NAME,
  'id',
  'role-permissions-groups',
);

export const getAllRolePermissionGroups = rolePermissionGroupsActions.getAll;
export const editRolePermissionGroups = rolePermissionGroupsActions.edit;
export const createRolePermissionGroups = rolePermissionGroupsActions.create;
export const getByIdRolePermissionGroups =
  rolePermissionGroupsActions.getDataById;
